module.exports = __webpack_public_path__ + "static/media/cool.3e175468.jpg";